import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state to indicate an error has occurred
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error or send it to an error reporting service
        console.error('Error caught in boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Render fallback UI if an error is caught
            return <h1>Something went wrong.</h1>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
